// extracted by mini-css-extract-plugin
module.exports = {"withDropdownText":"language_selector-module--withDropdownText--3rwrY","arrow":"language_selector-module--arrow--3ipRJ"};